<template>
  <Authenticated>
    <section v-for="site in siteMap" :key="site" class="main">
      <h2>{{ site.site }}</h2>
      <div class="unit-container">
        <div v-for="kds in site.stations.kds" :key="kds" class="unit" @click.stop.prevent="openKDSModal(kds)">
          <h4>{{ kds.name }}</h4>
          <p>Tracking:</p>
          <ul class="list">
            <li v-for="category in kds.categories" :key="category" class="list-item">
              {{ category }}
            </li>
          </ul>
        </div>
        <div class="new" @click.stop.prevent="openKDSModal(site.site, true)">Add KDS Station</div>
      </div>
    </section>
    <KDSStationModal :open="showKDSModal" :station="KDSStation" :newStation="newStation" @update="updateStations" @close="close" />
    <div v-if="loading" class="loading-overlay">
      <LoadingSpinner :spinnerMessage="'Updating stations...'" />
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "../../_layouts/Authenticated.vue";
import KDSStationModal from "./KDSStationModal.vue";
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";
import LoadingSpinner from "@monolith/components";

export default {
  name: "KDSPage",

  components: {
    Authenticated,
    KDSStationModal,
    LoadingSpinner,
  },
  data() {
    return {
      showKDSModal: false,
      newStation: false,
      KDSStation: {},
    };
  },
  methods: {
    close() {
      this.showKDSModal = false;
    },
    openKDSModal(incoming, newStation = false) {
      this.KDSStation = {
        name: null,
        site: null,
        categories: [],
      };
      this.newStation = newStation;
      if (newStation) {
        this.KDSStation.site = incoming;
        this.showKDSModal = !this.showKDSModal;
        return;
      }
      this.KDSStation = incoming;
      this.showKDSModal = !this.showKDSModal;
    },

    async updateStations(typeOfUpdate, typeOfStation, incomingStation) {
      this.$store.dispatch("loading", true);
      let newStations = [];
      this.siteMap.forEach((site) => {
        if (site.site == incomingStation.site) {
          site.stations[typeOfStation].forEach((station) => {
            if (typeOfUpdate === "update") {
              if (station.name == incomingStation.name) {
                newStations.push(incomingStation);
              } else {
                newStations.push(station);
              }
            } else if (typeOfUpdate === "delete") {
              if (station.name != incomingStation.name) {
                newStations.push(station);
              }
            }
          });
        } else {
          site.stations[typeOfStation].forEach((station) => {
            newStations.push(station);
          });
        }
      });
      this.showKDSModal = false;
      this.showPOSModal = false;

      await api.post("/api/company/update_stations", {
        doc: newStations,
        station_type: `get_${typeOfStation}`,
        site: incomingStation.site,
      });
      this.$store.dispatch("initialSiteMap");
      this.$store.dispatch("loading", false);
    },
  },
  computed: {
    ...mapGetters({
      channels: "channels",
      siteMap: "siteMap",
      siteSettings: "siteSettings",
      companySettings: "companySettings",
      timezone: "timezone",
      sites: "sites",
      customerDetails: "customerDetails",
      getSubscribedProducts: "getSubscribedProducts",
      companyName: "companyName",
      loading: "loading",
    }),
  },
  mounted() {},

  watch: {
    async siteMap() {
      await this.$store.dispatch("setSubscribedProducts");
      await this.$store.dispatch("updateSubscription");
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "public/stylesheets/layout";
// @import "public/stylesheets/wrapper";
// @import "public/stylesheets/actions";
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--opacity-background);
  z-index: 1000;
}
.header {
  margin: 1.5rem;
}
.scroll-wrapper {
  overflow-y: auto;
  height: 100vh;
}
.main {
  background-color: var(--primary-colour);
  padding: 1rem 2rem;
  margin: 2rem;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  perspective: 1000px;
  h2 {
    text-transform: capitalize;
    margin-left: 0;
  }
  .unit-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .new {
      background-color: var(--action-colour);
      color: var(--secondary-text-colour);
      border-radius: 0.5rem;
      padding: 1rem 2rem;
      margin: 0.5rem;
      box-shadow: var(--box-shadow);
      cursor: pointer;
      height: 25%;
    }
    .unit {
      height: 10rem;
      margin: 0.5rem;
      padding: 1rem;
      width: 20%;
      box-shadow: var(--box-shadow);
      background-color: var(--tertiary-colour);
      border-radius: 10px;
      cursor: pointer;
      overflow: auto;

      h4,
      p {
        margin: 0.5rem 0;
        text-transform: capitalize;
      }
      .list {
        margin: 0.25rem;
        margin-left: 0;
        .list-item {
          list-style: circle;
          color: var(--action-colour);
        }
      }
    }
  }
}
@media only screen and (orientation: portrait) {
  #content {
    .main {
      padding: 1rem;
      border-radius: 0.5rem;
      margin: 1rem 1rem !important;
      .unit-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .unit {
          width: 16rem;
        }
      }
    }
  }
}
</style>
